import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import apiClient from "common/src/api/ApiClient";
import Input from "common/src/components/widget/Input";
import Button from "common/src/components/widget/Button";
import FormContainer from "common/src/components/form/FormContainer";
import { useForm } from "common/src/hooks/form/formHook";
import { useDispatch } from 'react-redux';
import {addErrorNotification, addSuccessNotification} from "../state/api/notifications";
import PromiseBuilder from "common/src/utils/PromiseUtils";

const RegistrationForm = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isBusy, setIsBusy] = useState(false);

    const schema = {
        firstName: yup.string().max(255, t('length_exceeded_error')).required(),
        lastName: yup.string().max(255, t('length_exceeded_error')).required(),
        username: yup.string().max(255, t('length_exceeded_error')).required(),
        email: yup.string().email().required()
    };

    const {
        values,
        getField,
        setFormNotDirty,
        handleSubmit,
        setValues,
        isEdited
    } = useForm(submitUser, {enabled: true}, schema);

    async function submitUser() {
        setIsBusy(true);
        const formData = {
            firstName: values.firstName,
            lastName: values.lastName,
            username: values.username,
            email: values.email,
            enabled: values.enabled
        };

        new PromiseBuilder()
            .then(async () => apiClient.post('/api/v1/user/register', formData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            }))
            .then(async (response) => {
                console.log('Registration response: ', response);
                if (response?.response?.status === 200 || response?.response?.status === 201) {

                }
                dispatch(addSuccessNotification({title: t('toast.success'), content: t('user.registered')}));
                setFormNotDirty();
                navigate("/", {replace: true});
            })
            .catch(async (response) => {
                console.error('Registration failed: ', response);
                if (response?.response?.status === 409) {
                    dispatch(addErrorNotification({title: t('toast.error'), content: t('user.registration_409_error')}));
                } else {
                    dispatch(addErrorNotification({title: t('toast.error'), content: t('user.registration_error')}));
                }
            })
            .finally(async () => {
                setIsBusy(false)
            })
            .run();

        setIsBusy(false);
    }

    return (
        <FormContainer onSubmit={handleSubmit} isEdited={isEdited}>
            <div className="card">
                <header className="card-header">
                    <p className="card-header-title">
                        <span className="icon fz fz-users medium mr-1"/>
                        <span>{t('user.register')}</span>
                    </p>
                </header>
                <div className="card-content">
                    <div className="columns is-multiline">
                        <div className="column is-half-tablet">
                            <Input label={t('user.firstName')} formField={getField("firstName")} required />
                        </div>
                        <div className="column is-half-tablet">
                            <Input label={t('user.lastName')} formField={getField("lastName")} required />
                        </div>
                    </div>
                    <div className="columns is-multiline">
                        <div className="column is-half-tablet">
                            <Input label={t('user.username')} formField={getField("username")} required />
                        </div>
                        <div className="column is-half-tablet">
                            <Input label={t('user.email')} formField={getField("email")} type="email" required />
                        </div>
                    </div>
                </div>
            </div>
            <Button isSubmit={true} color="primary" label={t('submit')} isLoading={isBusy} />
            <Button color="primary" isOutlined={true} label={t('cancel')} onClick={() => navigate("/")} />
        </FormContainer>
    );
};

export default RegistrationForm;
